import styled from 'styled-components'
import { giphyBlack, giphyCharcoal, giphyLightGrey } from '@giphy/colors'
import { UploadFieldBlock } from '../../blocks'
import CreationToolUploadField from '../../../types/upload-field'
import { CreationToolUploadTag } from '../types'
import CopilotTagManager from '../copilot/tag-manager'
import { IconButton } from 'ui'
import CollapsibleField from '../../form-fields/upload/field-collapsible'
import { Pill } from 'ui'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
    padding: 30px 0 10px;
    margin: 15px 0 0 0;
    border-radius: 6px;
    border: 1px dashed ${giphyCharcoal};
    background-color: ${giphyBlack};
    padding-top: 15px;
    padding-bottom: 15px;
    padding: 20px;
    position: relative; /* Added */
    > div {
        margin-bottom: 0;
    }
`

const StyledPill = styled(Pill)`
    position: absolute;
    top: -3px;
    right: 0;
    margin: 15px 20px;
    padding: 0 0 0 10px;
    > span {
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const StyledIconButton = styled(IconButton)`
    pointer-events: none;
`

type Props = {
    className?: string
    sourceId?: string
    pills?: CreationToolUploadTag[]
    field: CreationToolUploadField
}

const CreationUploadTagManagerField = ({ className, sourceId }: Props) => {
    return (
        <Container className={className}>
            <StyledPill>
                Staff Only
                <StyledIconButton color="#fff" icon="info" iconColor={giphyLightGrey} inverted onClick={console.log} />
            </StyledPill>
            <CollapsibleField className={className} field={CreationToolUploadField.TagManager}>
                <CopilotTagManager sourceId={sourceId} />
            </CollapsibleField>
        </Container>
    )
}

export default CreationUploadTagManagerField
